import * as React from 'react';

import CloudWithArrow16 from './CloudWithArrow16';

export const cloudWithArrow16 = () => <CloudWithArrow16 />;

export default {
    title: 'Icon|Line|CloudWithArrow16',
    component: CloudWithArrow16,
    parameters: {
        notes: "`import CloudWithArrow16 from 'box-ui-elements/es/icon/line/CloudWithArrow16';`",
    },
};
